import Vue from 'vue';
import Vuex from 'vuex';
import { Notification } from 'element-ui';
import { resetRouter } from '@/router';
import { permList } from '@/api/sys/perm';
import { login, loginTz, logout, userInfo } from '@/api/sys/users';
import { tokenName } from '@/config/net.config';
import { enterpriseInfo } from '@/api/schoolEnterprise/manage';
import { campusType } from '@/config/edition.config';
import { getPersonInfo } from '@/api/jxjy/person';
import { getjxjyJsGw } from '@/api/jxjy/learningInput';

Vue.use(Vuex);

export default {
  state: {
    token: localStorage.getItem(tokenName),
    userInfo: {},
    // 所在部门
    userDeptInfo: {},
  },
  getters: {
    token: (state) => state.token,
    userInfo: (state) => state.userInfo,
    userDeptInfo: (state) => state.userDeptInfo,
  },
  mutations: {
    /**
     * @description 设置token
     * @param {*} state
     * @param {*} token
     */
    setToken(state, token) {
      state.token = token;
      localStorage.setItem(tokenName, token);
    },
    /**
     * @description 设置用户名
     * @param {*} state
     * @param {*} userInfo
     */
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    /**
     * @description 获取所在部门
     * @param {*} state
     * @param {*} userDeptInfo
     */
    setUserDeptInfo(state, userDeptInfo) {
      state.userDeptInfo = userDeptInfo;
    },
  },
  actions: {
    /**
     * @description 登录
     * @param {*} { commit }
     * @param {*} userInfo
     */
    async login({ commit }, userInfo) {
      let res = undefined;
      res = campusType === 5 ? await loginTz(userInfo) : await login(userInfo);
      if (res && res.code === 1 && res.data) {
        const token = res.data.token;
        //  localStorage.setItem('userTypes', data.type) //后端说要减1
        console.log(token);
        if (token) {
          commit('setToken', token);
          if (res.data.editPwdFlag === 1) {
            // todo：第一次登录修改密码
          } else {
            const hour = new Date().getHours();
            let welcomeText =
              hour < 8
                ? '早上好'
                : hour <= 11
                ? '上午好'
                : hour <= 13
                ? '中午好'
                : hour < 18
                ? '下午好'
                : '晚上好';
            if (res.data.week === '6') {
              welcomeText += ',今天是星期六,放下手中的工作休息一下吧!';
            } else if (res.data.week === '7') {
              welcomeText += ',今天是星期日,放下手中的工作休息一下吧!';
            }
            Notification.success({
              title: `欢迎登录，${res.data.xm}`,
              message: welcomeText,
            });
          }
        } else {
          const message = `登录接口异常，未正确返回token...`;
          Notification.error({
            title: '错误',
            message,
          });
          throw message;
        }
      } else {
        throw `登录失败！`;
      }
    },

    /**
     * @description 获取用户信息
     * @param {*} { commit, dispatch, state }
     * @returns
     */
    async getUserInfo({ commit, dispatch }) {
      let res = {};
      const userType = sessionStorage.getItem('userType');
      res = userType === '7' ? await enterpriseInfo() : await userInfo();

      if (res && res.code === 1 && res.data) {
        commit('setUserInfo', res.data);
        dispatch('getDeptInfo');

        let roles = res.data.postList;
        if (roles && roles.length) {
          if (res.data.support === '1') {
            roles = roles.map((item) => ({ ...item, postName: '超级管理员' }));
            dispatch('setAdmin', true, { root: true });
          } else {
            let permRes = undefined;
            let postId = roles[0].postId;
            const postInfo = await getPersonInfo();

            if (
              postInfo &&
              postInfo.code == 1 &&
              postInfo.data &&
              postInfo.data.gwId &&
              postInfo.data.gwmc
            ) {
              postId = postInfo.data.gwId;
              roles = [
                {
                  postName: postInfo.data.gwmc,
                  postId: postInfo.data.gwId,
                },
              ];
            }
            permRes = await permList({
              postId: postId,
              os: 'jxjy',
              types: 0,
            });
            if (permRes && permRes.code === 1) {
              const permArray = permRes.data;
              // 报修管理
              if (permArray && permArray.length) {
                if (
                  (permArray.indexOf('upms:sys:staff:repair') !== -1 ||
                    permArray.indexOf('upms:sys:config:repairSite') !== -1 ||
                    permArray.indexOf('upms:sys:config:repairItem') !== -1) &&
                  permArray.indexOf('upms:repair:logistics') === -1
                )
                  permArray.push('upms:repair:logistics');
              }
              dispatch('setPermission', permArray || [], { root: true });
            }
          }
          dispatch('setRoles', roles, { root: true });
          dispatch('setCurrentRole', roles[0], { root: true });
        }
      }
    },
    async getDeptInfo({ getters, commit }) {
      if (getters.userInfo.gh) {
        const res = await getjxjyJsGw({ gh: getters.userInfo.gh });
        if (res?.code === 1 && res?.data) commit('setUserDeptInfo', res.data);
      }
    },

    async changeRole({ dispatch }, role) {
      dispatch('setCurrentRole', role, { root: true });
      const res = await permList({
        postId: role.postId,
        os: 'jxjy',
        types: 0,
      });
      if (res && res.code === 1) {
        dispatch('setPermission', res.data || [], { root: true });
        // dispatch("setRoutes", { root: true });
      }
    },

    /**
     * @description 退出登录
     * @param {*} { dispatch }
     */
    async logout({ dispatch }) {
      await logout();
      await dispatch('resetAll');
      localStorage.clear();
      let cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        let eqPos = cookie.indexOf('=');
        let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        // 设置过期时间为过去的时间戳，达到删除 cookie 的效果
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT';
      }
    },

    /**
     * @description 重置
     * @param {*} { commit, dispatch }
     */
    async resetAll({ commit, dispatch }) {
      commit('setUserInfo', {});
      commit('setRoutes', [], { root: true });
      await dispatch('setToken', '');
      await dispatch('setAdmin', false, { root: true });
      await dispatch('setRoles', [], { root: true });
      await dispatch('setCurrentRole', {}, { root: true });
      await dispatch('setPermission', [], { root: true });
      await resetRouter();
      localStorage.removeItem(tokenName);
      localStorage.removeItem('post');
    },

    setToken({ commit }, token) {
      commit('setToken', token);
    },
  },
};
